import { useUser } from '@hooks'
import { SplitFactoryProvider } from '@splitsoftware/splitio-react'
import { ReactNode, useEffect, useState } from 'react'
// Create the config for the SDK factory.
const getSdkConfig = (companyId: string) => {
  return {
    core: {
      authorizationKey: process.env.REACT_APP_SPLIT_API_KEY as string,
      key: companyId,
    },
  }
}

export const SplitIOProvider = ({ children }: { children: ReactNode }) => {
  const [sdkConfig, setSdkConfig] = useState(Object)
  const { user } = useUser()
  useEffect(() => {
    if (user) {
      setSdkConfig(getSdkConfig(user.company.uuid))
    }
  }, [user])

  return <SplitFactoryProvider config={sdkConfig}>{children}</SplitFactoryProvider>
}
